import {
  Flex,
  CurrencyValue,
  WalletAddress,
  Box,
  BoxProps,
  LinkWrapper,
  ActionCard
} from '@blockanalitica/ui';
import styled from 'styled-components';
import { Link } from 'react-router';

const KpiTitle = styled(Box)<BoxProps>`
  font-size: ${(props) => props.theme.sizes[-1]};
  font-weight: 600;
  color: ${(props) => props.theme.colors.muted};
  white-space: nowrap;
`;

export default function WalletHeading({
  walletAddress,
  totalSupply,
  totalBorrow,
  healthRate,
  network
}: {
  walletAddress: string;
  totalSupply: string | null;
  totalBorrow: string | null;
  healthRate: string | null;
  network: string;
}) {
  return (
    <Flex
      flexDirection={['column', 'row']}
      gap={['m', 'xs']}
      justifyContent="space-between">
      <WalletAddress
        gap="s"
        options={{
          showCopyBtn: true,
          showEthScanLink: true,
          showDebankLink: true,
          sizes: {
            icon: '8',
            walletAddressHeader: '4'
          },
          network: network
        }}
        address={walletAddress}
        justifyContent="center"
      />

      <LinkWrapper
        to={`/${network}/wallets/${walletAddress}`}
        // @ts-ignore
        as={Link}>
        <ActionCard variant="orange" fontSize="2">
          <Flex flexDirection="column">
            <KpiTitle>Total Supply</KpiTitle>
            <CurrencyValue value={totalSupply} options={{ currency: 'USD' }} />
          </Flex>
          <Flex flexDirection="column">
            <KpiTitle>Total Borrow</KpiTitle>
            <CurrencyValue value={totalBorrow} options={{ currency: 'USD' }} />
          </Flex>
          <Flex flexDirection="column">
            <KpiTitle>Health Rate</KpiTitle>
            <CurrencyValue value={healthRate} />
          </Flex>
        </ActionCard>
      </LinkWrapper>
    </Flex>
  );
}
